<template>
  <div>
    <v-form v-model="mainFormValid">
      <v-row>
        <v-col>
          <v-text-field
            v-model="internalValue.name"
            :label="$t('ontime.fields.version.name')"
            :rules="$options.rules.name"
            @input="change"
          />
        </v-col>
        <v-col cols="auto">
          <ag-language-field
            v-model="internalValue.lang"
            :label="$t('general.language')"
            @input="change"
          />
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            v-model="internalValue.defaultVersion"
            :disabled="!create && disabledDefaultOptions"
            :label="$t('ontime.fields.version.default')"
            @change="change"
          />
        </v-col>
      </v-row>
      <v-textarea
        v-model="internalValue.questionOne"
        :label="$t('ontime.fields.version.questionOne')"
        :rules="$options.rules.questionOne"
        @input="change"
      />
      <v-textarea
        v-model="internalValue.questionTwo"
        :label="$t('ontime.fields.version.questionTwo')"
        :rules="$options.rules.questionTwo"
        @input="change"
      />
    </v-form>
  </div>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'
import AgLanguageField from 'src/components/common/AgLanguageField'

export default {
  name: 'VersionForm',
  components: {
    AgLanguageField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    create: {
      type: Boolean,
      default: false,
    },
    disabledDefaultOptions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalValue: null,
    mainFormValid: false,
  }),
  computed: {
    isValidVersion () {
      return this.mainFormValid
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
        this.$emit('validate', this.isValidVersion)
      },
    },
    isValidVersion: {
      immediate: true,
      handler () {
        this.$emit('validate', this.isValidVersion)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.isValidVersion)
    },
  },
  rules: {
    name: [
      FormRules.required('error.form.required'),
      FormRules.minLength('error.form.minLength', { length: 5 }),
    ],
    questionOne: [
      FormRules.required('error.form.required'),
    ],
    questionTwo: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
